
import React from "react";
import Image from "@/components/ui/image";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";

// Mainospartnereiden data
const rakennusAffiliates = [
  {
    name: "Virtasenkauppa.fi",
    logo: "/lovable-uploads/3e519b8f-90a6-4412-9973-89462594dd81.png",
    url: "https://pin.virtasenkauppa.fi/t/t?a=1637080522&as=1854031059&t=2&tk=1",
    description: "Autotarvikkeet, työkalut, piha- ja puutarhatarvikkeet sekä ruuvit ja muuttolaatikot yhdessä paikassa.",
    highlights: [
      "Yli 70 vuotta kokemusta, suomalainen perheyritys",
      "Nopeat toimitukset ja laaja valikoima (60 000 tuotetta)"
    ]
  },
  {
    name: "Tavararahaksi.fi",
    logo: "/lovable-uploads/d04b33a1-687e-4a23-86b8-eb3d3511bde1.png",
    url: "https://go.tavararahaksi.fi/t/t?a=1889615125&as=1854031059&t=2&tk=1",
    description: "Suomen suurin käytetyn tavaran verkkokauppa – säästä rahaa ja luontoa.",
    highlights: [
      "Laaja valikoima huonekaluja ja kodin tavaraa käytettynä",
      "Edulliset hinnat, osta verkosta"
    ]
  },
  {
    name: "Valaisinmestari.fi",
    logo: "/lovable-uploads/3f3159e2-0047-4039-84fe-4243ca42db67.png",
    url: "https://go.adt228.com/t/t?a=1875853254&as=1854031059&t=2&tk=1",
    description: "Kaikki valaistusratkaisut, sisään ja ulos. Noin 50 000 valaisinta ja lamppua.",
    highlights: [
      "Nopeat toimitukset ja useita tarjouksia",
      "Laatu, design ja sujuva verkko-ostoskokemus"
    ]
  },
  {
    name: "KitchenOne",
    logo: "/lovable-uploads/b2cc3e2f-f430-4f29-8a26-e550c7f025c7.png",
    url: "https://on.kitchenone.fi/t/t?a=1577687407&as=1854031059&t=2&tk=1",
    description: "Keittiön koneet, tarvikkeet ja huipputason brändejä verkosta.",
    highlights: [
      "Laaja kattaus kodinkoneita ja tarvikkeita",
      "Erilaisia herkkuja ja laatutuotteita kotiin"
    ]
  },
  {
    name: "Hulténs",
    logo: "/lovable-uploads/1bbc5058-d53b-4ce6-8ff4-751b8d9a7fa0.png",
    url: "https://ion.hultens.fi/t/t?a=1810775001&as=1854031059&t=2&tk=1",
    description: "Ulkokalusteet, sisäkalusteet ja grillit. Yli 10 000 premium-tuotetta.",
    highlights: [
      "Tunnetut merkit, suuri valikoima",
      "Ruotsalainen palvelu ja nopea toimitus"
    ]
  }
];

const RakennustarvikeAds: React.FC = () => (
  <section className="py-6 md:py-8 bg-gradient-to-b from-gray-50 to-white">
    <div className="container mx-auto px-4">
      <h2 className="mb-4 md:mb-6 flex items-center justify-center text-xl md:text-3xl font-bold text-center text-blue-700">
        Rakennustarvikkeet ja remontointi – suosittelemme kumppaneitamme
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
        {rakennusAffiliates.map((affiliate, idx) => (
          <Card key={affiliate.name} className="overflow-hidden h-full hover:shadow-lg transition-shadow border border-blue-100">
            <a
              href={affiliate.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block h-full"
            >
              <div className="bg-white flex items-center justify-center h-16 sm:h-20 md:h-28 border-b">
                <Image
                  src={affiliate.logo}
                  alt={`${affiliate.name} logo`}
                  fallbackSrc="/placeholder.svg"
                  width={180}
                  height={60}
                  className="max-h-full max-w-[80%] object-contain"
                  objectFit="contain"
                  priority
                />
              </div>
              <CardContent className="p-3 md:p-4 pt-4 md:pt-5">
                <h3 className="font-bold text-base md:text-lg mb-1 md:mb-2 text-blue-700">{affiliate.name}</h3>
                <p className="text-gray-700 text-xs md:text-sm mb-2 md:mb-3 line-clamp-2">{affiliate.description}</p>
                <ul className="mb-2 text-xs md:text-sm text-gray-600 space-y-1">
                  {affiliate.highlights.map((line, i) => (
                    <li key={i} className="flex items-start">
                      <span className="mr-1">•</span>
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-2 md:mt-3 pt-2 border-t flex items-center text-blue-600 text-xs md:text-sm font-medium">
                  <ArrowRight className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" />
                  <span>Katso verkkokauppa</span>
                </div>
              </CardContent>
            </a>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default RakennustarvikeAds;
